import { motion } from "framer-motion";

const LEFT_IMAGE_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_zero-signals-landing/artifacts/0norkkk4_5906645721220322514.jpg";

const STORIA_IMAGE_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_zero-signals-landing/artifacts/4991b7mv_Logo%20FAMI%20-%20Logo%20ZS%20-%20Zeta%20%2811%29.png";

export default function WhoWeAre() {
  return (
    <>
      {/* CHI SIAMO */}
      <section
        id="chisiamo"
        data-testid="who-we-are-section"
        className="relative border-t border-brand-gold/20 py-24 lg:py-32"
      >
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:gap-20 lg:px-10 items-stretch">

          {/* SINISTRA: Immagine Statica */}
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5 h-[350px] sm:h-[450px] lg:h-full min-h-full"
          >
            <div className="relative h-full w-full overflow-hidden rounded-2xl border border-white/10 bg-[#121212] group flex items-center justify-center p-1">

              {/* Immagine principale — INGRANDITA */}
              <img
                src={LEFT_IMAGE_URL}
                alt="Zero Signals Overview"
                className="h-full w-full scale-[1.18] object-contain transition-transform duration-500 group-hover:scale-[1.23]"
              />

              {/* Overlay Sfumato */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent z-10 pointer-events-none" />

              {/* Badge Capitolo */}
              <div className="absolute bottom-5 left-5 right-5 z-20 flex justify-between items-center">
                <div className="inline-flex items-center gap-2 rounded-full border border-brand-neon-blue/40 bg-black/60 px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-brand-neon-blue backdrop-blur">
                  <span className="h-1.5 w-1.5 rounded-full bg-brand-neon-blue animate-pulse" />
                  Powered by Progetto FAMI
                </div>
              </div>
            </div>
          </motion.div>

          {/* DESTRA: testo */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-7 flex flex-col justify-center"
          >
            <div className="mb-5 inline-flex items-center gap-3 text-xs font-medium uppercase tracking-[0.28em] text-brand-neon-blue">
              <span className="h-px w-4 bg-brand-gold" />
              Chi Siamo
            </div>

            <h2 className="font-display text-4xl font-black leading-[1.02] tracking-tighter md:text-5xl text-white">
              We are the people <br />
              <span className="text-gradient-gold">
                behind the silence.
              </span>
            </h2>

            <p className="mt-7 max-w-xl text-base leading-relaxed text-white/65 sm:text-lg">
              Professionisti informatici e appassionati di analisi sportiva
              hanno unito competenze diverse per costruire un progetto italiano
              dedicato all&apos;analisi quantitativa dello sport.
            </p>

            <div className="mt-6 max-w-xl">
              <h3 className="font-display text-lg font-bold text-gradient-gold bg-clip-text text-transparent inline-block">
                In che modo?
              </h3>

              <p className="mt-1 text-base leading-relaxed text-white/55">
                ZeroSignals mette a disposizione strumenti per analizzare i
                mercati sportivi attraverso dati, probabilità e indicatori
                quantitativi, raccolti in un&apos;unica interfaccia.
              </p>
            </div>

            <div className="mt-5 max-w-xl">
              <h3 className="font-display text-lg font-bold text-gradient-gold bg-clip-text text-transparent inline-block">
                Perché?
              </h3>

              <p className="mt-1 text-base leading-relaxed text-white/55">
                Per ridurre il rumore e rendere l&apos;analisi più strutturata.
                L&apos;obiettivo non è sostituire il giudizio dell&apos;utente,
                ma fornirgli informazioni organizzate con cui costruire le
                proprie valutazioni.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-6 border-t border-white/5 pt-8">
              <div>
                <div className="font-display text-2xl font-bold text-white">
                  2019
                </div>
                <div className="mt-1 text-xs uppercase tracking-[0.18em] text-white/45">
                  Nascita del Progetto
                </div>
              </div>

              <div>
                <div className="font-display text-2xl font-bold text-gradient-gold">
                  2026
                </div>
                <div className="mt-1 text-xs uppercase tracking-[0.18em] text-white/45">
                  Evoluzione in ZeroSignals
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* LA NOSTRA STORIA */}
      <section
        id="lanostrastoria"
        data-testid="our-story-section"
        className="relative border-t border-brand-gold/20 py-24 lg:py-32"
      >
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:gap-20 lg:px-10">

          {/* SINISTRA: testo */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            <div className="mb-5 inline-flex items-center gap-3 text-xs font-medium uppercase tracking-[0.28em] text-brand-neon-blue">
              <span className="h-px w-4 bg-brand-gold" />
              Storia
            </div>

            <h2 className="font-display text-4xl font-black leading-[1.02] tracking-tighter md:text-5xl text-white">
              Da{" "}
              <span className="text-white/40 line-through">
                Sc*paBook
              </span>{" "}
              <br />
              a <span className="text-gradient-gold">ZeroSignals.</span>
            </h2>

            <p className="mt-7 max-w-xl text-base leading-relaxed text-white/65 sm:text-lg">
              La nostra evoluzione non è un semplice cambio di brand, ma un
              reset filosofico. Siamo cresciuti insieme alla nostra community,
              trasformando un software di analisi in un ecosistema predittivo
              avanzato.
            </p>

            <ol className="mt-10 space-y-6">
              {[
                {
                  k: "01",
                  t: "L'Origine - 2019",
                  d: "Sc*paBook nasce con un'idea precisa: abbattere le opinioni e far parlare i dati. Da lì abbiamo costruito le nostre prime fondamenta matematiche.",
                },
                {
                  k: "02",
                  t: "La Maturazione",
                  d: "Anni di perfezionamento dei modelli algoritmici e l'espansione della community. Il nostro prodotto è andato oltre il suo nome originario.",
                },
                {
                  k: "03",
                  t: "L'Evoluzione",
                  d: "ZeroSignals rappresenta la nostra stessa visione originaria, evoluta per analizzare i mercati sportivi attraverso un approccio sempre più strutturato e data-driven.",
                },
              ].map((step) => (
                <li
                  key={step.k}
                  className="group flex gap-5 border-l border-white/10 pl-6 transition-colors hover:border-brand-gold/60"
                >
                  <div className="font-display text-sm font-bold tracking-tight text-brand-gold">
                    {step.k}
                  </div>

                  <div>
                    <div className="font-display text-lg font-bold text-white">
                      {step.t}
                    </div>

                    <p className="mt-1 max-w-md text-sm leading-relaxed text-white/55">
                      {step.d}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </motion.div>

          {/* DESTRA: typographic art e foto integrata */}
          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-5"
          >
            <div className="sticky top-32 overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br from-[#121212] to-[#0A0A0A] p-8 group">

              <div className="font-display text-[120px] font-black leading-[0.85] tracking-tighter text-white/[0.04] sm:text-[160px]">
                0/0
              </div>

              <div className="relative -mt-20 sm:-mt-28">
                <div className="text-xs uppercase tracking-[0.22em] text-brand-neon-blue">
                  Il Nostro Motto
                </div>

                <div className="mt-3 flex flex-col gap-1 font-display text-2xl font-bold leading-tight tracking-tight">
                  <span className="text-white">
                    &ldquo;Zero rumore.
                  </span>

                  <span className="text-gradient-gold bg-clip-text text-transparent block">
                    Zero Scuse.&rdquo;
                  </span>
                </div>

                <div className="mt-6 h-px w-full bg-gradient-to-r from-brand-gold/60 via-brand-neon-purple/40 to-transparent" />

                <p className="mt-4 text-sm leading-relaxed text-white/55">
                  Abbiamo trasformato anni di esperienza in uno strumento
                  accessibile a chiunque voglia strutturare le proprie analisi.
                  Un motore di calcolo racchiuso in un&apos;interfaccia
                  essenziale: pochi passaggi, nessuna distrazione, dati
                  organizzati in un&apos;unica schermata.
                </p>

                {/* SECONDA FOTO — INGRANDITA */}
                <div className="mt-8 overflow-hidden rounded-xl border border-white/10 aspect-video relative bg-[#181818] flex items-center justify-center p-1">
                  <img
                    src={STORIA_IMAGE_URL}
                    alt="Zero Signals Interface Focus"
                    className="h-full w-full scale-[1.10] object-contain transition-transform duration-500 group-hover:scale-[1.5]"
                    loading="lazy"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none" />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
}